class DropdownClose extends HTMLElement {
  constructor() {
    super();
  }

  closeDesktopVersion(blurActiveElement) {
    if (blurActiveElement) document.activeElement.blur();

    const form = this.closest('form');
    if (!form) return;

    const searchInput = form.querySelector('[name="q"]');
    if (!searchInput) return;

    const clearButton = form.querySelector('clear-input');
    if (!clearButton) return;

    searchInput.value = '';
    clearButton.handleInput();
  }

  handleClick(event) {
    const detailsElement = this.closest('details');

    if (!detailsElement) return this.closeDesktopVersion(true);

    const summary = detailsElement.querySelector('summary');

    if (!summary) return this.closeDesktopVersion(true);

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    detailsElement.classList.add('animate-out');

    summary.focus();
    detailsElement.classList.remove('menu-opening');

    setTimeout(() => {
      detailsElement.removeAttribute('open');

      detailsElement.classList.remove('animate-out');
    }, 200);

    bodyScroll.clear();
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick.bind(this));
  }
}

customElements.define('dropdown-close', DropdownClose);
